import {useMemo} from 'react';
import {type Template} from '@chekin/core';
import {
  buildBrandingVariables,
  type BrandingVariables,
} from 'utils/branding/brandingTokens';

export function useTemplateCssVariables(
  template: Template | undefined,
  fontsReady = false,
): BrandingVariables {
  return useMemo(
    () => buildBrandingVariables(template, fontsReady),
    [template, fontsReady],
  );
}
